// extracted by mini-css-extract-plugin
module.exports = {"modalCardTitle":"ProductFormModal_modalCardTitle_125sS"};